export const TraceXLogoCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    viewBox="0 0 151.32 151.35"
  >
    <defs>
      <clipPath id="clip-path">
        <path
          id="Path_3760"
          data-name="Path 3760"
          d="M197.82,142.74l15.99-15.99-15.99-15.99,5.85-21.84-21.84-5.85-5.85-21.84-21.84,5.85L138.15,51.09,122.16,67.08l-21.84-5.85L94.47,83.07,72.63,88.92l5.85,21.84L62.49,126.75l15.99,15.99-5.85,21.84,21.84,5.85,5.85,21.84,21.84-5.85,15.99,15.99,15.79-15.79,21.75,5.65,6.02-21.81,21.95-5.88ZM128.96,161.1l-3.37-12.57-12.57,3.37,3.37-12.57-12.57-3.37,9.2-9.2-9.2-9.2,12.57-3.37-3.37-12.57,12.57,3.37,3.37-12.57,9.2,9.2,9.2-9.2,3.37,12.57,12.57-3.37-3.37,12.57,12.57,3.37-9.2,9.2,9.2,9.2-12.57,3.37,3.42,12.76-13.68-3.56-3.22,11.66-8.29-8.29Z"
        />
      </clipPath>
      <pattern id="pattern" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 162 162">
        <image
          width="162"
          height="162"
          xlinkHref="data:image/png;base64,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"
        />
      </pattern>
    </defs>
    <g id="BrandNewPLLogo" transform="translate(-62.49 -51.06)">
      <g id="star_containing_path" opacity="0.9">
        <g id="Group_2185" data-name="Group 2185">
          <g id="Group_2184" data-name="Group 2184" clipPath="url(#clip-path)">
            <g id="Group_2183" data-name="Group 2183">
              <rect
                id="Rectangle_1738"
                data-name="Rectangle 1738"
                width="160.47"
                height="160.71"
                transform="translate(58.036 42.876)"
                fill="url(#pattern)"
              />
            </g>
          </g>
        </g>
      </g>
      <path id="start_green" d="M175.98,61.24l9.25,34.45-34.5,9.24-9.25-34.49Z" fill="#69ee5f" />
      <path id="end_blue" d="M138.16,51.11,112.9,76.31l25.26,25.26,25.25-25.26Z" fill="#27d9e5" opacity="0.6" />
      <g id="overlap_shapes" opacity="0.5">
        <path
          id="Path_3761"
          data-name="Path 3761"
          d="M172.5,117.51l-12.57-3.37,3.37-12.57-12.57,3.36-3.37-12.57-9.2,9.21-9.2-9.21-3.37,12.57-12.57-3.36,3.37,12.57-12.57,3.37,9.2,9.2-9.2,9.2,12.57,3.37-3.37,12.57,12.57-3.37,3.37,12.57,9.2-9.2,8.29,8.29,3.22-11.66,13.68,3.56-3.42-12.76,12.57-3.37-9.2-9.2Z"
          fill="none"
        />
        <path
          id="Path_3762"
          data-name="Path 3762"
          d="M146.45,160.14l-6.31,22.84,13.81,3.59,9.46-9.47Z"
          fill="#27d9e5"
          opacity="0.55"
        />
        <path
          id="Path_3763"
          data-name="Path 3763"
          d="M146.45,160.14l-6.31,22.84,13.81,3.59,9.46-9.47Z"
          fill="#27d9e5"
          opacity="0.5"
        />
        <path
          id="Path_3764"
          data-name="Path 3764"
          d="M103.82,135.91l-21.93-5.88L78.5,142.69l9.26,9.27Z"
          fill="#27d9e5"
          opacity="0.7"
        />
        <path
          id="Path_3765"
          data-name="Path 3765"
          d="M103.82,135.91l-21.93-5.88L78.5,142.69l9.26,9.27Z"
          fill="#27d9e5"
          opacity="0.65"
        />
        <path
          id="Path_3766"
          data-name="Path 3766"
          d="M172.5,117.51l21.93,5.87,3.39-12.66-9.27-9.27Z"
          fill="#27d9e5"
          opacity="0.4"
        />
        <path
          id="Path_3767"
          data-name="Path 3767"
          d="M172.5,117.51l21.93,5.87,3.39-12.66-9.27-9.27Z"
          fill="#27d9e5"
          opacity="0.3"
        />
        <path
          id="Path_3768"
          data-name="Path 3768"
          d="M103.82,117.51,87.76,101.45l-9.26,9.27,3.39,12.66Z"
          fill="#27d9e5"
          opacity="0.7"
        />
        <path
          id="Path_3769"
          data-name="Path 3769"
          d="M103.82,117.51,87.76,101.45l-9.26,9.27,3.39,12.66Z"
          fill="#27d9e5"
          opacity="0.75"
        />
        <path
          id="Path_3770"
          data-name="Path 3770"
          d="M113.02,101.57l-5.88-21.93L94.48,83.03,91.09,95.69Z"
          fill="#27d9e5"
          opacity="0.8"
        />
        <path
          id="Path_3771"
          data-name="Path 3771"
          d="M113.02,101.57l-5.88-21.93L94.48,83.03,91.09,95.69Z"
          fill="#27d9e5"
          opacity="0.75"
        />
        <path
          id="Path_3772"
          data-name="Path 3772"
          d="M172.5,135.91l16.05,16.05,9.27-9.27-3.39-12.66Z"
          fill="#27d9e5"
          opacity="0.4"
        />
        <path
          id="Path_3773"
          data-name="Path 3773"
          d="M172.5,135.91l16.05,16.05,9.27-9.27-3.39-12.66Z"
          fill="#27d9e5"
          opacity="0.45"
        />
        <path
          id="Path_3774"
          data-name="Path 3774"
          d="M163.35,152.04l5.83,21.74,12.54-3.37,3.51-12.69Z"
          fill="#27d9e5"
          opacity="0.5"
        />
        <path
          id="Path_3775"
          data-name="Path 3775"
          d="M163.35,152.04l5.83,21.74,12.54-3.37,3.51-12.69Z"
          fill="#27d9e5"
          opacity="0.45"
        />
        <path
          id="Path_3776"
          data-name="Path 3776"
          d="M128.96,161.05,112.9,177.1l9.27,9.27,12.66-3.39Z"
          fill="#27d9e5"
          opacity="0.55"
        />
        <path
          id="Path_3777"
          data-name="Path 3777"
          d="M128.96,161.05,112.9,177.1l9.27,9.27,12.66-3.39Z"
          fill="#27d9e5"
          opacity="0.6"
        />
        <path
          id="Path_3778"
          data-name="Path 3778"
          d="M113.02,151.85l-21.93,5.87,3.39,12.66,12.66,3.4Z"
          fill="#27d9e5"
          opacity="0.65"
        />
        <path
          id="Path_3779"
          data-name="Path 3779"
          d="M113.02,151.85l-21.93,5.87,3.39,12.66,12.66,3.4Z"
          fill="#27d9e5"
          opacity="0.6"
        />
        <path
          id="Path_3780"
          data-name="Path 3780"
          d="M163.3,101.57l21.93-5.88-3.39-12.66-12.66-3.39Z"
          fill="#27d9e5"
          opacity="0.3"
        />
        <path
          id="Path_3781"
          data-name="Path 3781"
          d="M163.3,101.57l21.93-5.88-3.39-12.66-12.66-3.39Z"
          fill="#27d9e5"
          opacity="0.25"
        />
        <path
          id="Path_3782"
          data-name="Path 3782"
          d="M128.96,92.36l5.87-21.92-12.66-3.4-9.27,9.27Z"
          fill="#27d9e5"
          opacity="0.8"
        />
        <path
          id="Path_3783"
          data-name="Path 3783"
          d="M128.96,92.36l5.87-21.92-12.66-3.4-9.27,9.27Z"
          fill="#27d9e5"
          opacity="0.85"
        />
        <path
          id="Path_3784"
          data-name="Path 3784"
          d="M147.36,92.36l16.05-16.05-9.26-9.27-12.67,3.4Z"
          fill="#27d9e5"
          opacity="0.25"
        />
        <path
          id="Path_3785"
          data-name="Path 3785"
          d="M147.36,92.36l16.05-16.05-9.26-9.27-12.67,3.4Z"
          fill="#27d9e5"
          opacity="0.85"
        />
      </g>
      <g id="white_atop_2_" opacity="0.3">
        <path
          id="Path_3786"
          data-name="Path 3786"
          d="M146.45,160.14l-8.29-8.29-9.2,9.2,5.87,21.93-12.66,3.39,15.99,15.99,15.79-15.79-13.81-3.59Z"
          fill="#fff"
          opacity="0.55"
        />
        <path
          id="Path_3787"
          data-name="Path 3787"
          d="M103.82,135.91l9.2-9.2-9.2-9.2-21.93,5.87L78.5,110.72,62.51,126.71,78.5,142.69l3.39-12.66Z"
          fill="#fff"
          opacity="0.7"
        />
        <path
          id="Path_3788"
          data-name="Path 3788"
          d="M172.5,117.51l-9.2,9.2,9.2,9.2,21.93-5.88,3.39,12.66,15.99-15.98-15.99-15.99-3.39,12.66Z"
          fill="#fff"
          opacity="0.4"
        />
        <path
          id="Path_3789"
          data-name="Path 3789"
          d="M113.02,101.57l12.57,3.36,3.37-12.57L112.9,76.31l9.27-9.27-21.84-5.85L94.48,83.03l12.66-3.39Z"
          fill="#fff"
          opacity="0.8"
        />
        <path
          id="Path_3790"
          data-name="Path 3790"
          d="M163.35,152.04l-13.68-3.56-3.22,11.66,16.96,16.96-9.46,9.47,21.75,5.65,6.02-21.81-12.54,3.37Z"
          fill="#fff"
          opacity="0.5"
        />
        <path
          id="Path_3791"
          data-name="Path 3791"
          d="M113.02,151.85l3.37-12.57-12.57-3.37L87.76,151.96l-9.26-9.27-5.86,21.84,21.84,5.85-3.39-12.66Z"
          fill="#fff"
          opacity="0.65"
        />
        <path
          id="Path_3792"
          data-name="Path 3792"
          d="M163.3,101.57l-3.37,12.57,12.57,3.37,16.05-16.06,9.27,9.27,5.85-21.84-21.83-5.85,3.39,12.66Z"
          fill="#fff"
          opacity="0.3"
        />
        <path
          id="Path_3793"
          data-name="Path 3793"
          d="M103.82,117.51l12.57-3.37-3.37-12.57L91.09,95.69l3.39-12.66L72.64,88.88l5.86,21.84,9.26-9.27Z"
          fill="#fff"
          opacity="0.75"
        />
        <path
          id="Path_3794"
          data-name="Path 3794"
          d="M188.55,151.96,172.5,135.91l-12.57,3.37,3.42,12.76,21.88,5.68-3.51,12.69,21.96-5.88-5.86-21.84Z"
          fill="#fff"
          opacity="0.45"
        />
        <path
          id="Path_3795"
          data-name="Path 3795"
          d="M128.96,161.05l-3.37-12.57-12.57,3.37-5.88,21.93-12.66-3.4,5.85,21.84,21.84-5.85-9.27-9.27Z"
          fill="#fff"
          opacity="0.6"
        />
        <path
          id="Path_3796"
          data-name="Path 3796"
          d="M147.36,92.36l3.37,12.57,12.57-3.36,5.88-21.93,12.66,3.39-5.86-21.84-21.83,5.85,9.26,9.27Z"
          fill="#fff"
          opacity="0.25"
        />
        <path
          id="Path_3797"
          data-name="Path 3797"
          d="M128.96,92.36l9.2,9.21,9.2-9.21-5.88-21.92,12.67-3.4L138.16,51.06,122.17,67.04l12.66,3.4Z"
          fill="#fff"
          opacity="0.85"
        />
      </g>
    </g>
  </svg>
);
